import React, { useEffect, useState } from "react";
import { authAPI } from "../../../apis";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../../functions/axios";
import { useDispatch } from "react-redux";
import { setProfilePicUrl } from "../../../redux/features/dataSlice";

const Avatar = ({
  name,
  bgColor = "#3498db",
  size = "100px",
  fontSize = "10px",
  profile,
}) => {
  const initial = name[0].toUpperCase();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { profilePicNav, profilePicUrl } = useSelector((state) => state.data);

  const avatarStyle = {
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: bgColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontWeight: "bold",
    fontSize: fontSize,
  };

  return (
    <div className="avatar" style={avatarStyle}>
      {profile && profilePicUrl ? (
        <img
          src={profilePicUrl}
          alt="Profile"
          style={{ width: "100%", height: "100%", borderRadius: "50%" }}
        />
      ) : (
        initial
      )}
    </div>
  );
};

export default Avatar;
